import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import Content, { HTMLContent } from "../components/Content";
import { Helmet } from "react-helmet";
import Seo from "../components/Seo";

// Popup Modal
import PopupModalComponent from "../components/PopupModal";

import Layout from "../components/Layout";
import FullWidthImage from "../components/FullWidthImage";
import DisplayContentHeader from "../components/DisplayContentHeader";
import TrailsListColor from "../components/TrailsListColor";
import Button from "../components/Button";
import ProductsWithTestimonials from "../components/ProductsWithTestimonials";

// eslint-disable-next-line
export const IndexPageTemplate = ({
  title,
  subtitle,
  image,
  secondImage,
  meta,
  body,
  helmet,
  testimonials,
}) => {
  const PageContent = HTMLContent || Content;
  const heroImage = getImage(image) || image;

  const secondHeroImage = getImage(secondImage) || secondImage;

  //const showTitle = meta.showTitle;
  //const author = meta.author;
  //const creationDate = meta.creationDate;
  let bookShuttleButton = (
    <>
      <center>
        <div style={{ width: "200px", marginTop: ".5em" }}>
          <Button
            title="Book Shuttle"
            link="/book-shuttle/"
            className="link-button-orange is-size-5 has-text-weight-bold"
          />
        </div>
      </center>
    </>
  );
  return (
    <div className=" light-cammo">
      {helmet || null}
      <Helmet>
        <script
          type="text/javascript"
          src="https://weatherwidget.io/js/widget.min.js"
        />
      </Helmet>
      <span className="homepage">
        <FullWidthImage
          img={heroImage}
          title={title}
          subheading={
            <>
              <div className="stop-pedaling-desktop">
                Where can we take you today?
              </div>
            </>
          }
          detail={bookShuttleButton}
          imgPosition="center"
        />
      </span>

      <div className="container hidden section section--gradient">
        <div className="content">
          <div className="content ">
            <DisplayContentHeader title={title} />
          </div>
        </div>
      </div>
      <section className="section section--gradient light-cammo pb-4 pt-0 mt-0">
        <div className="mt-2 pt-2 pt-4 pb-4">
          <div className="content dark-gray mt-0 pt-0">
            <PageContent className="" content={body} />
          </div>
        </div>
      </section>
      <div className="section dark-cammo ">
        <div className="columns gap-2">
          <div className="column is-6 fp-bike-trails">
            <div className="fp-inner px-0 mx-0">
              <div className="light-gray fp-padding">
                <Link to="/mtb-shuttles" title="Trails We Shuttle">
                  <h2 className="perm">
                    Bike
                    <br /> Trails
                  </h2>
                </Link>
                <hr className="gradient" />
                <Link to="/mtb-shuttles" title="Trails We Shuttle">
                  <h3 className="poppins">Trails We Shuttle</h3>
                </Link>
              </div>
            </div>
          </div>
          <div className="column is-6 fp-shuttle">
            <div className="fp-inner px-0 mx-0">
              <div className="light-gray fp-padding">
                <Link to="/departure-locations" title="Meeting Locations">
                  <h2 className="perm">
                    Shuttle
                    <br /> Locations
                  </h2>
                </Link>
                <hr className="gradient" />
                <Link to="/departure-locations" title="Meeting Locations">
                  <h3 className="poppins">Meeting Locations</h3>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TrailsListColor />
      <ProductsWithTestimonials />
      {secondImage ? (
        <div className="black-bg">
          <FullWidthImage
            img={secondHeroImage}
            subheading={
              <>
                Recover Faster, Stay Fresh For Tomorrow.
                {bookShuttleButton}
              </>
            }
            imgPosition="center"
          />
        </div>
      ) : null}

      <section className="section section--gradient light-cammo pb-1">
        <div>
          <span className="full-width-title">Local Weather</span>
        </div>
      </section>
      <section
        className="section section--gradient pb-1"
        style={{ backgroundColor: "#eaeaea" }}
      >
        <div className="container">
          <div className="content ">
            <div className="m-4 weatherwidget-io-div">
              <a
                className="weatherwidget-io link"
                href="https://forecast7.com/en/38d57n109d55/moab/?unit=us"
                data-label_1="Moab, Utah"
                data-label_2="Weather"
                theme="dark"
              >
                Moab, Utah, Weather
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

IndexPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  secondImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.shape({
    showTitle: PropTypes.bool,
    author: PropTypes.string,
    creationDate: PropTypes.string,
  }),
  body: PropTypes.string,
  helmet: PropTypes.object,
};

const IndexPage = ({ data }) => {
  const { markdownRemark: post } = data;

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  let imageSrc =
    post.frontmatter.image.childImageSharp.gatsbyImageData.images.fallback.src;

  return (
    <Layout>
      <IndexPageTemplate
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
        image={post.frontmatter.image}
        secondImage={post.frontmatter.secondImage}
        meta={post.frontmatter.meta}
        body={post.html}
        helmet={
          <Seo
            title={post.frontmatter.title}
            summary={post.frontmatter.summary}
            image={imageSrc}
            article={false}
          />
        }
      />
      {post.frontmatter.popup?.isEnabled &&
        <PopupModalComponent data={post.frontmatter.popup} isOpen={isOpen} handleClose={handleClose} />
      }
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default IndexPage;

export const indexPageQuery = graphql`
  query IndexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        subtitle
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        secondImage {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        meta {
          showTitle
          author
          creationDate
        }
        summary
        popup {
          isEnabled
          title
          subheading
          detail
          buttonText
          buttonUrl
          background {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                layout: FULL_WIDTH
                placeholder: BLURRED
              )
            }
          }
        }
      }
    }
  }
`;
